import { ActionCreator } from 'redux';
import { ChangeContentAction } from './types';
import { ContentType } from '../types/core';

export const changeContent: ActionCreator<ChangeContentAction> = (content: ContentType): ChangeContentAction => {
    return {
        type: 'CHANGE_CONTENT',
        content: content,
    };
};
